export default "__VITE_PUBLIC_ASSET__986ac3e3__"